import { desktop } from '@hg/stylizator/utils'
import styled, { css } from 'styled-components'

import { useGlobalState } from 'app/store'

export const useHelloBar = (blockKey = 'honeygain-components/hello-bar') => {
  const [blocks] = useGlobalState('reusableBlocks')
  const [isHeroCampaignCTAVisible] = useGlobalState('isHeroCampaignCTAVisible')
  const [pageId] = useGlobalState('pageId')
  const helloBarBlockData = blocks.get(blockKey)
  const helloBarProps = helloBarBlockData?.attrs ?? {}
  const isHelloBarEnabled = helloBarProps?.enabled ?? false
  const pageIds = helloBarProps?.pageIds ?? []

  if (blockKey === 'honeygain-components/hello-bar') {
    const showOnCurrentPage = !pageIds.includes(pageId)
    const showHelloBar = isHelloBarEnabled && !isHeroCampaignCTAVisible && showOnCurrentPage

    return { showHelloBar, helloBarBlockData }
  }
  const showOnAllPages = pageIds.length === 0
  const showOnCurrentPage = pageIds.includes(pageId)
  const showHelloBar = isHelloBarEnabled && !isHeroCampaignCTAVisible && (showOnAllPages || showOnCurrentPage)

  return { showHelloBar, helloBarBlockData }
}

export const TopContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 1000;

  & > * {
    position: relative;
  }

  & .hello-bar-container {
    display: none;

    @media ${desktop} {
      display: block;
    }
  }
`

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: sticky;
  bottom: 0;
  z-index: 999;

  @media ${desktop} {
    display: none;
  }

  & > * {
    position: relative;
  }
`

interface AnimateProps {
  $animate?: boolean
  $height: string
  $enabled?: boolean
}

export const Animate = styled.div<AnimateProps>`
  ${(props) =>
    props.$enabled &&
    css`
      max-height: 0;
      transition: max-height 0.15s ease-out;
      overflow: hidden;
    `}
  ${(props) => props.$animate && `max-height: ${props.$height};`}
`

export const HeaderPlaceholder = styled.div`
  height: 64px;
  width: 100%;
  background-color: white;
`
